import { Container, Grid } from "@mui/material";

import TraineeShow from "./TraineeShow";

const Trainee = () => {
  return (
    <>
      <Container sx={{ mt: 4 }} maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <TraineeShow />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Trainee;
